import React, { useState } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { closeModalAction } from "../../../redux/modal/modalActions";
import { setProOrderStatusAction } from "../../../redux/proOrders/proOrdersAction";
import theme from "../../styles/theme";

const Container = styled.div``;

const Title = styled.div`
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  margin-bottom: 20px;
`;

const Text = styled.p`
  color: ${(props) => (props.color ? props.color : props.theme.grey)};
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
`;

const Button = styled.button`
  background-color: #ffffff;
  color: ${(props) => props.color};
  font-size: 18px;
  width: 150px;
  padding: 15px;
  border: ${(props) => `1px solid ${props.color}`};
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    border: none;
    background-color: ${(props) => props.color};
    color: #ffffff;
  }
`;

const TextInput = styled.textarea`
  display: block;
  margin: 20px auto 20px auto;
  width: 100%;
  padding: 10px;
  font-size: 15px;
  border-radius: 5px;
  border: 1px solid
    ${(props) => (props.error ? props.theme.lightRed : props.theme.lighterGrey)};
`;

const CancelOrderModal = ({
  subOrderId,
  closeModalAction,
  setProOrderStatusAction,
}) => {
  const [messageText, setMessageText] = useState("");
  const [textError, setTextError] = useState(true);

  return (
    <Container>
      <Title>ANNULER LA COMMANDE</Title>
      <Text>
        Merci de bien vouloir préciser la raison de l'annulation de la commande
        ci dessous :
      </Text>

      <TextInput
        error={textError}
        onChange={(e) => {
          if (e.target.value === "") {
            setTextError(true);
            setMessageText(e.target.value);
          } else {
            setTextError(false);
            setMessageText(e.target.value);
          }
        }}
        value={messageText}
        placeholder="Raison de l'annulation"
      />
      <Text color={theme.lightRed}>
        Attention, en annulant cette commande vous devrez rembourser le montant
        perçu pour la vente ainsi que les frais de transaction Stripe payés par
        La Chariotte pour cette transaction.
      </Text>
      <ButtonsContainer>
        <Button
          onClick={(e) => {
            e.preventDefault();
            closeModalAction();
          }}
          color={theme.lightRed}
        >
          RETOUR
        </Button>
        <Button
          onClick={(e) => {
            e.preventDefault();
            if (messageText !== "") {
              console.log(messageText);
              closeModalAction();
              setProOrderStatusAction(subOrderId, 4, messageText);
            } else {
              setTextError();
            }
          }}
          color={theme.orange}
        >
          ANNULER
        </Button>
      </ButtonsContainer>
    </Container>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  closeModalAction,
  setProOrderStatusAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(CancelOrderModal);
